// Splits a string that is a path in an object or array into pieces separated by index
const createPathParts = (path: string) => path.match(/\.?\w*\[\d+\](\.\w+)*/g);

export default createPathParts;
